// extracted by mini-css-extract-plugin
export default {"youtube":"youtubeIcon__youtube__G8a3m","currentColor":"youtubeIcon__currentColor__urkMy"};